import { all } from "redux-saga/effects";
import { watchColorCreateWorker, watchColorViewWorker } from "../interface-saga";

export default function* interfaceRootSaga() {
  yield all([
    watchColorViewWorker(),
    watchColorCreateWorker()
  ]);
}
